import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteDialogComponent } from 'src/app/shared/confirm-delete-dialog/confirm-delete-dialog.component';
import { ConfirmStageDialogComponent } from 'src/app/shared/confirm-stage-dialog/confirm-stage-dialog.component';
@Component({
  selector: 'app-new-project-list',
  templateUrl: './new-project-list.component.html',
  styleUrl: './new-project-list.component.css'
})
export class NewProjectListComponent {
  // Expose Math to template
  Math = Math;
displayedColumns: string[] = ['srNo',
    'projectName', 'projectManager','assignedTo',
    'startDate', 'endDate', 'stage', "action"
  ];


  dataSource = new MatTableDataSource([]);
  searchKeyword = "";
  selectedStage: string = "";
  stages: any[] = [
    {id: 1, name: 'Pre-Planning'}, 
    {id: 2, name: 'Planning'}, 
    {id: 3, name: 'Survey'}, 
    {id: 4, name: 'Design Revisions & Scope Adjustments'}, 
    {id: 5, name: 'Execution'}, 
    {id: 6, name: 'Closure'}
  ];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  
  // Pagination properties
  pagination: any = {
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    hasNextPage: false,
    hasPrevPage: false,
    limit: 10
  };
  currentPage: number = 0;
  pageSize: number = 10;
  constructor(
    private apiService: ApiService,
    private toastrMsgService: ToastrMsgService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute
  ) {}



  ngOnInit(): void {
    this.route.queryParamMap.subscribe((qp) => {
      const stage = (qp.get('stage') || '').trim();
      this.selectedStage = stage;
      this.currentPage = 0;
      if (this.paginator) {
        this.paginator.pageIndex = 0;
      }
      this.fetchData();
    });
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    
    // Subscribe to paginator page events for server-side pagination
    if (this.paginator) {
      this.paginator.page.subscribe(() => {
        this.currentPage = this.paginator.pageIndex;
        this.pageSize = this.paginator.pageSize;
        this.fetchData();
      });
    }
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim();
    this.searchKeyword = filterValue;
    // Reset to first page when searching
    this.currentPage = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.fetchData();
  }
  filterByStatus(event: any) {
    console.log(event.target.value);
    const stageValue = event.target.value;
    this.selectedStage = stageValue;
    // Reset to first page when filtering
    this.currentPage = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.fetchData();
  }
  fetchData() {
    const params: any = { 
      keyword: this.searchKeyword ? this.searchKeyword : "",
      page: this.currentPage + 1, // API uses 1-based page numbers
      limit: this.pageSize
    };
    
    // Add stage filter if selected
    if (this.selectedStage) {
      // Find the stage ID from the stages array
      const selectedStageObj = this.stages.find(s => s.name === this.selectedStage || s.id.toString() === this.selectedStage);
      if (selectedStageObj) {
        params.stage = selectedStageObj.name;
      } else {
        // If it's already a numeric ID, use it directly
        params.stage = this.selectedStage;
      }
    }
    
    this.apiService.getProjectCommonAll(params).subscribe({
      next: (res: any) => {
        console.log(res);

        this.dataSource.data = res.data || [];
        
        // Update pagination metadata from API response
        if (res.pagination) {
          this.pagination = {
            currentPage: res.pagination.currentPage || 1,
            totalPages: res.pagination.totalPages || 1,
            totalCount: res.pagination.totalCount || 0,
            hasNextPage: res.pagination.hasNextPage || false,
            hasPrevPage: res.pagination.hasPrevPage || false,
            limit: res.pagination.limit || 10
          };
          
          // Update paginator properties (only if they changed to avoid triggering events)
          if (this.paginator) {
            if (this.paginator.length !== this.pagination.totalCount) {
              this.paginator.length = this.pagination.totalCount;
            }
            const expectedPageIndex = this.pagination.currentPage - 1; // Convert to 0-based index
            if (this.paginator.pageIndex !== expectedPageIndex) {
              this.paginator.pageIndex = expectedPageIndex;
            }
            if (this.paginator.pageSize !== this.pagination.limit) {
              this.paginator.pageSize = this.pagination.limit;
            }
            
            // Update component state to match paginator
            this.currentPage = expectedPageIndex;
            this.pageSize = this.pagination.limit;
          }
        }
      },
      error: (err) => {
        // console.log(err);
        // this.toastrMsgService.error(err.error.errorMessage);
        this.toastrMsgService.error("No Projects found");
        
      },
      complete: () => console.log('Observable complete'),
    });
  }

  deleteProject(item: any) {
  const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
    width: '400px',
    data: { itemName: item.project_name }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
        this.apiService.deleteProjectCommonId(item.id).subscribe({
      next: (res: any) => {
        console.log(res);
        this.toastrMsgService.success("Project deleted successfully");
        // Reset to first page after deletion if current page becomes empty
        if (this.dataSource.data.length === 1 && this.currentPage > 0) {
          this.currentPage = 0;
          if (this.paginator) {
            this.paginator.pageIndex = 0;
          }
        }
        this.fetchData();
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
    }
  });
}
stageProject(item: any) {
  const dialogRef = this.dialog.open(ConfirmStageDialogComponent, {
    width: '600px',
    data: { 
      project: item,
      itemName: item.project_name 
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      // Handle stage update logic here
      console.log('Stage updated for project:', item.project_name, 'with data:', result);
      
      // Prepare the payload
      const payload = {
        stage: result.stages,
        stages: result.stages,
        assigned_to: result.assigned_to,
        date: result.date,
        assignedStaffName: result.assignedStaffName
      };

      // API call to update project stage
      this.apiService.updateProjectStage(result.projectId || item.id || item.project_id, payload).subscribe({
        next: (res: any) => {
          console.log('Stage update response:', res);
          this.toastrMsgService.success(res.message || "Project stage updated successfully");
          this.fetchData();
          if (result.stages === 'Survey') {
            const projectId = result.projectId || item.id || item.project_id;
            this.router.navigate(['/home/add-survey'], { queryParams: { projectId, projectName: item.project_name } });
          }
        },
        error: (err) => {
          console.error('Stage update error:', err);
          this.toastrMsgService.error(err.error?.message || err.error?.errorMessage || "Failed to update project stage");
        },
        complete: () => console.log('Stage update complete')
      });
    }
  });
}


  getStatusColor(status: string | number): 'primary' | 'accent' | 'warn' {
    // Handle numeric stage IDs
    const stageId = typeof status === 'number' ? status : 
                    typeof status === 'string' && !isNaN(Number(status)) ? Number(status) : null;
    
    if (stageId !== null) {
      switch (stageId) {
        case 1: // Pre-Planning
        case 2: // Planning
          return 'primary';
        case 3: // Survey
        case 4: // Design Revisions & Scope Adjustments
          return 'accent';
        case 5: // Execution
        case 6: // Closure
          return 'warn';
        default:
          return 'primary';
      }
    }
    
    // Handle string stage names
    switch (status) {
      case 'Pre-Planning':
      case 'Planning':
        return 'primary';
      case 'Survey':
      case 'Design Revisions & Scope Adjustments':
        return 'accent';
      case 'Execution':
      case 'Closure':
        return 'warn';
      default:
        return 'primary';
    }
  }

}
